import { useLang } from "../../context/LanguageContext";
import {
  Wifi,
  Snowflake,
  ChefHat,
  Tv,
  Car,
  Heart,
  Waves,
  Sparkles,
  Maximize2,
} from "lucide-react";

const ICONS = {
  wifi: Wifi,
  ac: Snowflake,
  kitchen: ChefHat,
  tv: Tv,
  parking: Car,
  family: Heart,
  beach: Waves,
  clean: Sparkles,
  space: Maximize2,
};

export default function Amenities() {
  const { t } = useLang();
  const items = Object.entries(t.amenities.items);
  return (
    <section
      id="amenities"
      data-testid="amenities-section"
      className="py-16 sm:py-24 lg:py-32 bg-[#F5F2EB] overflow-x-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-10 sm:mb-16">
          <p className="uppercase text-xs sm:text-sm tracking-[0.25em] text-[#6B705C] mb-3 sm:mb-4">
            {t.amenities.overline}
          </p>
          <h2 className="font-serif text-3xl sm:text-5xl lg:text-6xl text-[#1A2B4C] tracking-tight leading-[1.05]">
            {t.amenities.title}
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3 sm:gap-6 lg:gap-8">
          {items.map(([key, label], idx) => {
            const Icon = ICONS[key];
            return (
              <div
                key={key}
                data-testid={`amenity-${key}`}
                className={`bg-white p-5 sm:p-8 lg:p-10 rounded-2xl border border-[#E9E2D3] hover:shadow-xl hover:-translate-y-1 transition-all duration-500 group ${
                  idx === 0 || idx === 4 ? "md:row-span-1 md:col-span-1" : ""
                }`}
              >
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#F5F2EB] flex items-center justify-center mb-4 sm:mb-6 group-hover:bg-[#1A2B4C] transition-colors">
                  <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-[#6B705C] group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-serif text-base sm:text-xl text-[#1A2B4C]">{label}</h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
